export type PickViewState =
  | { status: 'loading' }
  | { status: 'error' }
  | { status: 'noTeam' }
  | { status: 'seasonClosed' }
  | { status: 'ready' };

type DerivePickViewStateParams = {
  isLoading: boolean;
  isError: boolean;
  hasTeam: boolean;
  isSeasonClosed: boolean;
};

export const derivePickViewState = ({
  isLoading,
  isError,
  hasTeam,
  isSeasonClosed
}: DerivePickViewStateParams): PickViewState => {
  if (isSeasonClosed) return { status: 'seasonClosed' };
  if (isLoading) return { status: 'loading' };
  if (isError) return { status: 'error' };
  if (!hasTeam) return { status: 'noTeam' };
  return { status: 'ready' };
};

export const isReadyState = (state: PickViewState): boolean =>
  state.status === 'ready';
